// extracted by mini-css-extract-plugin
export default {"confirm-reactivate":"reactivate-button_confirm-reactivate__guZyf"};